import React from "react";
import { Truck, RotateCcw, ShieldCheck, Clock } from "lucide-react";
import GoldDivider from "../components/GoldDivider";
import { CONTACT } from "../lib/constants";

export default function Shipping() {
  return (
    <div data-testid="shipping-page">
      <section className="hero-noir py-20 px-4 md:px-8 text-center">
        <span className="text-xs uppercase tracking-[0.3em] text-[#B8860B]">Informations</span>
        <h1 className="font-display text-4xl md:text-6xl text-white mt-3 mb-4">Livraison & Retours</h1>
        <GoldDivider />
      </section>

      <div className="max-w-4xl mx-auto px-4 md:px-8 py-16 space-y-12">
        <Block icon={Truck} title="Livraison">
          Nous livrons partout à Abidjan et dans toute la Côte d'Ivoire. Les délais varient généralement
          entre 24h et 72h selon votre localisation. Les frais de livraison sont confirmés lors de la
          validation de votre commande, en fonction de votre commune.
        </Block>
        <Block icon={Clock} title="Délais de préparation">
          Votre commande est préparée avec soin dans les 24 heures ouvrées. Vous recevez une confirmation
          par WhatsApp avec le suivi de votre livraison.
        </Block>
        <Block icon={RotateCcw} title="Retours & Échanges">
          Vous disposez de 7 jours après réception pour nous retourner un article qui ne vous conviendrait pas,
          dans son état et son emballage d'origine. L'échange ou le remboursement est effectué dès réception
          du produit retourné.
        </Block>
        <Block icon={ShieldCheck} title="Garantie & Satisfaction">
          Tous nos produits sont vérifiés avant expédition. En cas de défaut à la réception, contactez-nous
          immédiatement sur WhatsApp au {CONTACT.phoneIntl} ou par email à {CONTACT.email} : nous trouverons
          rapidement une solution.
        </Block>
      </div>
    </div>
  );
}

function Block({ icon: Icon, title, children }) {
  return (
    <div className="flex gap-5">
      <div className="w-12 h-12 shrink-0 rounded-full border border-[#B8860B]/30 flex items-center justify-center text-[#B8860B]">
        <Icon size={22} strokeWidth={1.5} />
      </div>
      <div>
        <h2 className="font-display text-2xl text-[#0A0A0A] mb-2">{title}</h2>
        <p className="text-neutral-600 leading-relaxed">{children}</p>
      </div>
    </div>
  );
}
